export default "__VITE_ASSET__DgNbAvNZ__"